const colors = {
  beige: {
    20: '#FAFBF9',
    40: '#F6F7F3',
    60: '#F2F4ED',
    100: '#EAEDE1',
    120: '#D6D7CB',
    140: '#C4C2AA',
    180: '#7A7562',
  },
  black: '#000000',
  /* Brand palette - see the landing redesign guide (section 4) */
  brand: {
    pink: '#FA2F5C',
    purple: '#CA58EF',
    cyan: '#44DCFF',
    navy: '#334768',
    deep: '#2C3E50',
    action: '#22C2FC',
    ink: '#2C3E50',
    muted: '#5D6A7B',
    soft: '#F4F6FA',
    line: '#E1E6EE',
    onDark: {
      title: '#FFFFFF',
      body: '#DCE4EF',
      muted: '#BDCADB',
      faint: '#C1CCDA',
      line: 'rgba(255, 255, 255, 0.14)',
    },
    surface: {
      card: '#FFFFFF',
      raised: '#FAFBFD',
      border: '#C6CFDD',
    },
  },
  correct: {
    base: '#67B430',
    'dark-80': '#CDD1DD',
    'light-20': '#EDEEF2',
  },
  gmBlue: {
    base: '#0F526F',
    'dark-60': '#638EA1',
    'dark-80': '#3D738A',
    'light-20': '#E6EDF0',
    'light-40': '#9FBAC5',
  },
  tbBlue: {
    base: '#57BEFF',
  },
  incorrect: {
    base: '#C42A2A',
    'dark-80': '#911F1F',
    'light-20': '#F2C2C2',
  },
  neutral: {
    base: '#E6E8EA',
    'dark-60': '#CCD3D5',
    'light-20': '#FCFCFC',
    'light-30': '#F5F6F7',
    'light-40': '#EDF0F2',
  },
  n: {
    '04': '#F5F5F5',
    10: '#E6E6E6',
    20: '#CCCCCC',
    40: '#999999',
    60: '#666666',
    100: '#000000',
  },
  pBlue: {
    100: '#9ED4FF',
    20: '#CADEF3',
    10: '#E9F7FB',
  },
  olive: {
    160: '#606D37',
    100: '#B7C378',
    60: '#C7E07D',
  },
  primary: {
    base: '#B5B5B5',
    'dark-60': '#647881',
    'dark-80': '#4A5D66',
    'dark-90': '#7e7e7e',
    'light-40': '#A6B5BD',
    'light-50': '#7D9099',
    'light-60': '#ABD5D8',
    0: '#244A78',
    100: '#96B5AD',
    120: '#7CA3A1',
    140: '#649295',
  },
  terracotta: {
    100: '#E4844F',
  },
  transparent: {
    base: 'transparent',
    black: 'rgba(0, 0, 0, 16%)',
  },
  warning: {
    base: '#EEBB0B',
    'dark-80': '#D93D1A',
    'light-20': '#E65427',
  },
  white: '#FFFFFF',
  khaki: {
    100: '#E3DABA',
  },
};

const gradients = {
  brand: 'linear-gradient(90deg, #FA2F5C 0%, #CA58EF 50%, #44DCFF 100%)',
};

const layout = {
  contentMaxWidth: '1280px',
  gutter: {
    desktop: '112px',
    smallDesktop: '72px',
    tablet: '48px',
    phone: '40px',
    compact: '32px',
  },
  sectionSpacing: {
    desktop: '92px',
    tablet: '66px',
    phone: '58px',
  },
  radius: {
    button: '8px',
    card: '12px',
    panel: '16px',
    surface: '18px',
  },
};

const measurements = {
  extraExtraLarge: '20px',
  extraExtraSmall: '1px',
  extraLarge: '16px',
  extraSmall: '2px',
  large: '12px',
  medium: '8px',
  shadows: {
    'elevation-1': '0px 1px 1px 0px',
    'elevation-2': '0px 1px 3px 0px',
    'elevation-3': '0px 2px 4px 0px',
    'elevation-4': '0px 4px 8px 0px',
    'elevation-5': '0px 8px 16px 0px',
    'elevation-6': '0px 16px 24px 0px',
    medium: '0px 0px 0px 5px',
    small: '0px 0px 0px 2px',
    extraSmall: '0px 0px 0px 1px',
  },
  small: '4px',
  zero: '0',
};

const typography = {
  fonts: {
    primary: 'Roboto',
    secondary: 'Raleway',
    body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    display:
      "'Inter Display', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  rootFontSize: '16px',
  sizes: {
    extraExtraHuge: '3.5rem', // 56px
    extraExtraLarge: '1.625rem', // 26px
    extraHuge: '3rem', // 48px
    extraLarge: '1.375rem', // 22px
    extraSmall: '0.75rem', // 12px
    huge: '2.25rem', // 36px
    large: '1.125rem', // 18px
    medium: '1rem', // 16px
    small: '0.875rem', // 14px
  },
  weights: {
    black: '900',
    bold: '700',
    medium: '500',
    regular: '400',
    thin: '300'
  },
};

const iconology = {
  sizes: {
    huge: '2rem', // 32px
    large: '1.625rem', // 26px
    medium: '1.25rem', // 20px
    small: '1.062rem', // 17px
  }
};

const baseTheme = {
  colors,
  gradients,
  layout,
  measurements,
  typography,
  iconology,
};

export type BaseTheme = typeof baseTheme;
export default baseTheme;
